var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.state === "loggedOut" && _vm.isExtranet
      ? _c("li", [
          _c("a", { attrs: { href: _vm.loginUrl } }, [_vm._v("Login")])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }